import { MaskedLines } from "@/components/Reveal";

interface PageHeroProps {
  eyebrow: string;
  titleLines: string[];
  description: string;
}

export const PageHero = ({ eyebrow, titleLines, description }: PageHeroProps) => (
  <section className="bg-ink pb-20 pt-36 text-paper lg:pb-28 lg:pt-44">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <p className="mb-6 text-xs uppercase tracking-[0.3em] text-gold" data-testid="page-eyebrow">
        {eyebrow}
      </p>
      <h1 className="font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">
        <MaskedLines lines={titleLines} />
      </h1>
      <p className="mt-8 max-w-2xl text-base leading-relaxed text-paper/70 md:text-lg">
        {description}
      </p>
    </div>
  </section>
);
